export { default } from "./method";
